export class PackListDto {
  material: string;
  lineItemId: number;
  qtyPacked: number;
  packListID?: number;
  packID?: number;
  loc?: string;
}
